import { useOutletContext, useParams } from "react-router";

import { BasePage } from "../components/base-page";
import { TranscriptionWithContext } from "../core/transcription/transcription-with-context";
import { TranscriptionOutletContext } from "../types/types";

export function TranscriptionPage() {
  const {
    mediaFile,
    setMediaFile,
    transcriptionConfiguration,
    setTranscriptionConfiguration,
    reset,
  } = useOutletContext<TranscriptionOutletContext>();
  const { transcriptId } = useParams<{
    transcriptId: string;
  }>();

  if (!transcriptId) throw new Error("No transcriptId found");

  return (
    <BasePage footer={false}>
      <TranscriptionWithContext
        transcriptId={transcriptId}
        mediaFile={mediaFile}
        setMediaFile={setMediaFile}
        transcriptionConfiguration={transcriptionConfiguration}
        setTranscriptionConfiguration={setTranscriptionConfiguration}
        reset={reset}
      />
    </BasePage>
  );
}
